import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#333', color: '#FFF' }}>
      <Box sx={{ textAlign: 'center' }}>
        <Typography sx={{ fontSize: { xs: '30px', sm: '40px', md: '54px' }, fontWeight: '500' }}>404 - Page Not Found</Typography>
        <Typography sx={{ fontSize: { xs: '16px', sm: '18px', md: '20px' }, fontWeight: '400' }}>Sorry, the page you are looking for does not exist.</Typography>
        <Button
          onClick={() => navigate('/')}
          variant="contained"
          sx={{
            background: '#FFF',
            color: '#333',
            '&:hover': {
              background: '#FFF',
              color: '#333',
            },
            fontSize: { xs: '16px', sm: '18px', md: '20px' },
            fontWeight: '500',
            my: '10px',
          }}
        >
          Go Back to Home
        </Button>
      </Box>
    </Box>
  );
};

export default NotFound;
